import { EndPointModel } from '@em/models/restapi/EndPoint.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class EndPointCollectionModel extends CollectionModel<EndPointModel> {
    public constructor() {
        super(EndPointModel);
    }
}
